export const bodyColors = [
    // First Row
    {
        id: "alpine-white-solid",
        name: "Alpine White (Solid)",
        hex: "#D2D0CE",
        prefix: "Alpine_White_Solid",
    },
    {
        id: "alpine-white-metallic",
        name: "Alpine White (Metallic)",
        hex: "#D2D0CE",
        prefix: "Alpine_White_Metallic"
    },
    {
        id: "baluga-black-solid",
        name: "Baluga Black (Solid)",
        hex: "#0B0B0B",
        prefix: "Baluga_Black_Solid"
    },
    {
        id: "santorini-black-metallic",
        name: "Santorini Black (Metallic)",
        hex: "#0B0B0B",
        prefix: "Santorini_Black_Metallic"
    },
    {
        id: "dark-grey-solid",
        name: "Dark Grey (Solid)",
        hex: "#3C3C3C",
        prefix: "Dark_Grey_Solid"
    },
    {
        id: "corris-grey-metallic",
        name: "Corris Grey (Metallic)",
        hex: "#505452",
        prefix: "Corris_Grey_Metallic"
    },
    {
        id: "nolita-grey-metallic",
        name: "Nolita Grey (Metallic)",
        hex: "#474F54",
        prefix: "Nolita_Grey_Metallic"
    },
    {
        id: "raf-blue-solid",
        name: "RAF Blue (Solid)",
        hex: "#2E3D42",
        prefix: "RAF_Blue_Solid"
    },
    {
        id: "aegan-blue-metallic",
        name: "Aegean Blue (Metallic)",
        hex: "#547B89",
        prefix: "Aegean_Blue_Metallic"
    },
    {
        id: "arles-blue-solid",
        name: "Arles Blue (Solid)",
        hex: "#224762",
        prefix: "Arles_Blue_Solid"
    },
    // Second Row
    {
        id: "tuscan-blue-solid",
        name: "Tuscan Blue (Solid)",
        hex: "#347298",
        prefix: "Tuscan_Blue_Solid"
    },
    {
        id: "blu-aegir-metallic",
        name: "Blu Aegir (Metallic)",
        hex: "#007FFF",
        prefix: "Blu_Aegir_Metallic"
    },
    {
        id: "velocity-blue-metallic",
        name: "Velocity Blue (Metallic)",
        hex: "#0000FF",
        prefix: "Velocity_Blue_Metallic"
    },
    {
        id: "tanzanite-purple-metallic",
        name: "Tanzanite Purple (Metallic)",
        hex: "#8B008B",
        prefix: "Tanzanite_Purple_Metallic"
    },
    {
        id: "buckingham-blue-metallic",
        name: "Buckingham Blue (Metallic)",
        hex: "#020408",
        prefix: "Buckingham_Blue_Metallic"
    },
    {
        id: "aintree-green-metallic",
        name: "Aintree Green (Metallic)",
        hex: "#0A2017",
        prefix: "Aintree_Green_Metallic"
    },
    {
        id: "willow-green-metallic",
        name: "Willow Green (Metallic)",
        hex: "#454938",
        prefix: "Willow_Green_Metallic"
    },
    {
        id: "british-racing-green-solid",
        name: "British Racing Green (Solid)",
        hex: "#143524",
        prefix: "British_Racing_Green_Solid"
    },
    {
        id: "coniston-green-solid",
        name: "Coniston Green (Solid)",
        hex: "#23462E",
        prefix: "Coniston_Green_Solid"
    },
    {
        id: "apple-green-metallic",
        name: "Apple Green (Metallic)",
        hex: "#00FF00",
        prefix: "Apple_Green_Metallic"
    },
    // Third Row
    {
        id: "grassmere-green-metallic",
        name: "Grassmere Green (Metallic)",
        hex: "#768D66",
        prefix: "Grassmere_Green_Metallic"
    },
    {
        id: "keswick-green-solid",
        name: "Keswick Green (Solid)",
        hex: "#52665F",
        prefix: "Keswick_Green_Solid"
    },
    {
        id: "atlantic-green-solid",
        name: "Atlantic Green (Solid)",
        hex: "#778D7A",
        prefix: "Atlantic_Green_Solid"
    },
    {
        id: "classic-beige-solid",
        name: "Classic Beige (Solid)",
        hex: "#F5F5DC",
        prefix: "Classic_Beige_Solid"
    },
    {
        id: "batumi-gold-metallic",
        name: "Batumi Gold (Metallic)",
        hex: "#FFD700",
        prefix: "Batumi_Gold_Metallic"
    },
    {
        id: "monaco-yellow-solid",
        name: "Monaco Yellow (Solid)",
        hex: "#FFD700",
        prefix: "Monaco_Yellow_Solid"
    },
    {
        id: "stormer-orange-metallic",
        name: "Stormer Orange (Metallic)",
        hex: "#CD590E",
        prefix: "Stormer_Orange_Metallic"
    },
    {
        id: "sanguinello-orange-metallic",
        name: "Sanguinello Orange (Metallic)",
        hex: "#FF4500",
        prefix: "Sanguinello_Orange_Metallic"
    },
    {
        id: "firenze-red-metallic",
        name: "Firenze Red (Metallic)",
        hex: "#FF0000",
        prefix: "Firenze_Red_Metallic"
    },
    {
        id: "monticello-red-metallic",
        name: "Monticello Red (Metallic)",
        hex: "#FF0000",
        prefix: "Monticello_Red_Metallic"
    },
];


export const rimColors = {
    "body-color": {
        id: "body-color",
        name: "Body Colour",
        hex: "#252525",
        prefix: "Body_Colour"
    },
    "black-solid": {
        id: "black-solid",
        name: "Black",
        hex: "#252525",
        prefix: "Black_Solid"
    },
    "white-solid": {
        id: "white-solid",
        name: "White",
        hex: "#252525",
        prefix: "Alpine_White_Solid"
    },
    "silver-metallic":{
        id: "silver-metallic",
        name: "Silver",
        hex: "#778D7A",
        prefix: "Silver_Metallic"
    },
    "black-solid-silver-lathed":{
        id: "black-solid-silver-lathed",
        name: "Diamond Cut",
        hex: "#778D7A",
        prefix: "Black_Solid_&_Silver_Lathed"
    }
}

export const rimStyles = [
    {
        id: "wolf",
        name: "Wolf",
        prefix: "Wolf_Body_Coloured",
        bodyColor: true,
        colors: ['body-color', 'white-solid', 'black-solid']
    },
    {
        id: "Modular",
        name: "Modular",
        prefix: "Modular_Body_Coloured",
        bodyColor: true,
        colors: ['body-color', 'white-solid', 'black-solid']
    },
    {
        id: "boost",
        name: "Boost",
        prefix: "Boost",
        bodyColor: false,
        colors: ['black-solid', 'silver-metallic'],
    },
    {
        id: "sawtooth",
        name: "Sawtooth",
        prefix: "Sawtooth",
        bodyColor: false,
        colors: ['black-solid', 'silver-metallic', 'black-solid-silver-lathed']
    },
    {
        id: "nemesis",
        name: "Nemesis",
        prefix: "Nemesis",
        bodyColor: false,
        colors: ['black-solid', 'silver-metallic']
    },
    {
        id: "challenger",
        name: "Challenger",
        prefix: "Challenger",
        bodyColor: false,
        colors: ['black-solid']
    }, 
]

export const fenders = [
    {
        id: "body-color",
        name: "Body Color",
        prefix: "Body_Colour",
    },
    {
        id: "black",
        name: "Black",
        prefix: "Black_Plastic_Matte",
    },
]

export const roofColors = [
    {
        id: "body-color",
        name: "Body Color",
        prefix: "Body_Color",
    },
    {
        id: "white",
        name: "White",
        prefix: "Alpine_White_Solid",
    },
    {
        id: "black",
        name: "Black",
        prefix: "Baluga_Black_Solid",
    }
]

export const roofs = [
    {
        id: "hardtop",
        name: "Hardtop",
        prefix: "Hardtop",
        colors: ['body-color', 'white', 'black'],
        bodyColor: true,
    },
    {
        id: "softtop",
        name: "Soft Top",
        prefix: "Softtop_Black",
        colors: ['black'],
        bodyColor: false,
    }
]

export const engines = [
    {
        id: "300-tdi",
        name: "300Tdi",
        prefix: "300_TDI",
        description: "The 300TDI is a 2.5ltr (2,495cc) 4 cylinder diesel engine and is widely considered to be one of Land Rovers finest engines. Produced from 1994-1998 the 300TDI is easily capable of keeping up with modern-day traffic and TATC also offers numerous upgrades to this engine including our Performance Pack, a modern VGT Turbo, an uprated Intercooler and a bespoke stainless exhaust system. Historically our best-seller the 300TDI is a modern classic.",
    },
    {
        id: "v8",
        name: "3.5ltr V8",
        prefix: "3.5_V8",
        description: "The Rover V8 uses gasoline and was in production in various forms from 1967 to 2006. Starting off life within General Motors Land Rover acquired the rights to their renowned V8 and went on to produce nearly 1,000,000 of these V8’s in various Land Rover and Rover products! With the ability to produce excellent performance figures the 3.5ltr V8 is an excellent choice and sounds amazing!",
    },
    {
        id: "td5",
        name: "TD5",
        prefix: "TD5",
        description: "The TD5 launched as the successor to the 300TDI and is a 2.5ltr 5 Cylinder Diesel Engine used in Land Rover products from 1998 to 2007. Capable of +200bhp the unit is highly tuneable and lends itself perfectly to powering all models of Land Rover. Defenders powered by the TD5 are now eligible for import into the USA and the TD5 can be considered as the “next generation” of powerplant for classic Defenders."
    },
    {
        id: "lt1",
        name: "LT1",
        prefix: "LT1",
        description: "For those seeking more power in their Defender TATC are able to install the stunning Gen 5 LT1 by General Motors. This engine option fits nicely within the Defender engine-bay and offers approximately 450bhp in Gen 5 configuration. Mated to an 8 Speed Auto Transmission this combination makes for effortless driving paired with exhilarating acceleration and performance.",
    },
    {
        id: "ev",
        name: "Full EV",
        prefix: "EV",
        description: "TATC is now able to offer all models of classic Defender with full state-of-the-art EV technology and up to 720Nm of Torque and 175 Miles of Range! With three different EV Packages available customers have significant choice and the ability to choose the perfect EV package based on Range, Performance and Budget. Each EV Package retains the Defenders unique 4x4 capability to ensure customers can still enjoy the outdoors and their adventure lifestyle.",
    }
]